import {
    isBetslipReceiptOpen,
    isBetslipOpen,
} from '../../shared/utils/betslip';
import { isLargeContainer } from '../../spa/Utils/ContainerSize';
import {
    RECOMMEND_SELECTIONS_DELAY_STATE_KEY,
} from '../../shared/services/recommendations';
import { getState } from '../../shared/utils/state';

import {
    RECOMMENDATION_LOCATION_BET_RECEIPT_NAME,
    RECOMMENDATION_LOCATION_BETSLIP_NAME,
    RECOMMENDATION_LOCATION_UNKNOWN_NAME,
} from '../betslip/constants';

import { MILLI_SECONDS_UNIT } from '../../shared/utils/constants';

/**
 * Handles recommended flag to betslip selections
 * @param {Object} userBetslip The user betslip object
 * @param {Object} recommendationsView The recommendation view object
 * @return {void}
 */
export function addRecommendedFlagToBetslipSelection({ userBetslip, recommendationsView }) {
    if (userBetslip.selections !== undefined) {
        Object.keys(userBetslip.selections)
            .forEach(selectionId => {
                if (userBetslip.selections[selectionId].recommended === undefined) {
                    if (recommendationsView.hasSelection(selectionId)) {
                        userBetslip.selections[selectionId].recommended = true;
                        if (isBetslipReceiptOpen()) {
                            userBetslip.selections[selectionId].recommendation_location = RECOMMENDATION_LOCATION_BET_RECEIPT_NAME;
                        } else if (isBetslipOpen()) {
                            userBetslip.selections[selectionId].recommendation_location = RECOMMENDATION_LOCATION_BETSLIP_NAME;
                        } else {
                            userBetslip.selections[selectionId].recommendation_location = RECOMMENDATION_LOCATION_UNKNOWN_NAME; // shouldn't happen
                        }
                    } else {
                        userBetslip.selections[selectionId].recommended = false;
                        userBetslip.selections[selectionId].recommendation_location = '';
                    }
                }
            });
    }
}

/**
 * Get the recommendSelectionsDelay. Used as a parameter for debouncing
 * calls to the BE when retrieving selections
 * @see recommendBetslipPlacementSelections
 * @returns {Number} value in milliseconds
 */
export function getRecommendSelectionsDelay() {
   let recommendSelectionsDelay = 0;
   if (isLargeContainer()) {
       recommendSelectionsDelay = getState(RECOMMEND_SELECTIONS_DELAY_STATE_KEY) * MILLI_SECONDS_UNIT;
   }

   return recommendSelectionsDelay;
}
